/**
 * Named max-width sizes for the CModal wrapper.
 *
 * CModal accepts a `size` prop that must be one of these keys, so every modal
 * in the app picks from the same consistent set of widths instead of hardcoding
 * arbitrary pixel values. `md` is the default.
 *
 * To add or change a size, edit this map — CModal validates its `size` prop
 * against these keys at runtime.
 */
export const MODAL_SIZES = {
  sm: "480px",
  md: "560px",
  lg: "720px",
  xl: "860px",
  xxl: "960px",
} as const;

export type ModalSize = keyof typeof MODAL_SIZES;
